export const ConstrictIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.121" height="9.121" viewBox="0 0 16.121 9.121">
      <g id="Grupo_779" data-name="Grupo 779" transform="translate(1.061 8.061) rotate(-90)">
        <line id="Linha_384" data-name="Linha 384" y1="7" x2="7" transform="translate(0 7)" fill="none" stroke="#005a9e" stroke-linecap="round" stroke-width="1.5"/>
        <line id="Linha_385" data-name="Linha 385" x2="7" y2="7" fill="none" stroke="#005a9e" stroke-linecap="round" stroke-width="1.5"/>
      </g>
    </svg>
  )